import { create } from 'zustand';

const useCompanyStore = create((set) => ({
  selectedCompany: null,
  setSelectedCompany: (company) => set({ selectedCompany: company }),
}));

export default useCompanyStore;
